import { useReactiveVar } from '@apollo/client';
import { entityContextVar } from './variables';
import { entityContextPermissions } from '../utils';

export const FlowPermissionType = {
  READ: 'read',
  WRITE: 'write'
};

export const useFlowPermissions = type => {
  const entityContext = useReactiveVar(entityContextVar);
  return entityContextPermissions[entityContext]?.[type];
};
